module.exports = __webpack_public_path__ + "static/img/sb33.1be6c3fb.png";